module.exports = __webpack_public_path__ + "img/blueRightArrow.3746edf9.svg";